import { Grid, TextField, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

type Props = {
  disabled?: boolean;
};

const CityControl = ({ disabled }: Props) => {
  const { t } = useTranslation();

  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const isEezyWork = watch("isEezyWork");
  const hasError = !!errors.city;

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("workHistory:city")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="city"
          control={control}
          rules={{
            required: { value: !isEezyWork, message: t("common:requiredField") },
          }}
          render={({ field: { name, value, onChange } }) => (
            <TextField
              autoComplete="off"
              fullWidth
              required={!isEezyWork}
              name={name}
              size="small"
              value={value}
              onChange={onChange}
              error={hasError}
              disabled={disabled}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default CityControl;
